<div class="d-flex flex-column align-items-center mb-md-5">
  <h4 class="text-center text-uppercase product-serie elsa-title-font">{{serie}}</h4>
  <h3 class="text-center text-uppercase product-name elsa-title-font">{{name}}</h3>
  <picture>
    <img class="product-img object-fit-cover" [src]="img" [alt]="name">
  </picture>
  <ng-container *ngIf="internalBoring">
  <span class="info-diameters font-weight-regular">{{'label_internal_boring'| translate}}</span>
  <span class="info-diameters font-weight-bold">{{internalBoring}}</span>
  </ng-container>
  <ng-container *ngIf="internalWelding">
  <span class="info-diameters font-weight-regular">{{'label_internal_welding'|translate}}</span>
  <span class="info-diameters font-weight-bold">{{internalWelding}}</span>
  </ng-container>
  <p class="text-center product-description text-uppercase ellipsized-description three-lines-text">{{description}}</p>
  <a [title]="name" appEmptyTitle class="btn btn-gray text-white btn-elsa mt-3 text-uppercase"
     [routerLink]="Paths.Product | page:[slug] | localize">{{'label_details' | translate}}</a>
</div>
